import React from "react";
import { Box, Pagination, Tab, Tabs } from "@mui/material";
import { TimeTrials } from "../../../../Admin/Task Verification/TimeTrials";
import { useGetEmployeeTimeTrialSubmissionsQuery } from "../../../../../redux-toolkit/features/time-trails/timeTrailsApiSlice";
import ProgressBar from "../../../../UI/ProgressBar";
import "../../../../Admin/Task Verification/Task Detailed/TaskDetailed.css";
import { EmployeeActivityEmpty } from "./EmployeeActivityEmpty";
import "./EmployeeActivityPage.css";

const sectionTabSx = {
  textTransform: "capitalize",
  fontWeight: "500",
  fontSize: "15px",
};

const PAGE_SIZE = 10;

export const EmployeeActivityTimeTrails = ({ employeeId }) => {
  const [openSection, setOpenSection] = React.useState("PENDING");
  const [sectionPages, setSectionPages] = React.useState({
    PENDING: 1,
    APPROVED: 1,
    REJECTED: 1,
  });

  const { data, isLoading, isFetching } =
    useGetEmployeeTimeTrialSubmissionsQuery(
      {
        userId: employeeId,
        status: openSection,
        page: sectionPages[openSection] || 1,
        limit: PAGE_SIZE,
      },
      { refetchOnMountOrArgChange: true, skip: !employeeId }
    );

  const submissions = data?.data?.submissions || [];
  const counts = data?.data?.counts || { pending: 0, approved: 0, rejected: 0 };
  const pagination = data?.data?.pagination || {
    totalPages: 1,
    totalResults: 0,
    page: 1,
  };

  const sectionConfig = [
    { key: "PENDING", label: "Pending", count: counts.pending || 0 },
    { key: "APPROVED", label: "Approved", count: counts.approved || 0 },
    { key: "REJECTED", label: "Rejected", count: counts.rejected || 0 },
  ];

  const activeTabIndex = Math.max(
    0,
    sectionConfig.findIndex((section) => section.key === openSection)
  );

  return (
    <div className="employeeActivityPage__section">
      <Box className="employeeActivityPage__statusTabs" sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTabIndex}
            onChange={(_event, newValue) =>
              setOpenSection(sectionConfig[newValue]?.key || "PENDING")
            }
            aria-label="employee time trail status tabs"
          >
            {sectionConfig.map((section) => (
              <Tab
                key={section.key}
                label={`${section.label} (${section.count})`}
                sx={sectionTabSx}
              />
            ))}
          </Tabs>
        </Box>
      </Box>

      {isLoading || isFetching ? (
        <div className="employeeActivityPage__loader">
          <ProgressBar />
        </div>
      ) : (
        <div className="employeeActivityPage__list">
          {submissions.length ? (
            <TimeTrials submissions={submissions} readOnly />
          ) : (
            <EmployeeActivityEmpty title="No Submissions Found!" />
          )}
        </div>
      )}

      <div className="employeeActivityPage__pagination">
        <Pagination
          count={Math.max(1, pagination.totalPages || 1)}
          shape="rounded"
          page={sectionPages[openSection] || 1}
          onChange={(_, newPage) =>
            setSectionPages((prev) => ({
              ...prev,
              [openSection]: newPage,
            }))
          }
        />
      </div>
    </div>
  );
};
